import request from '@/utils/requestnew'
import baseUrl from './baseUrl'
import commonJs from '@/utils/common'

const BASE_URL = baseUrl + '/log'

export default {
    //小程序日志
    apiList(params) {
        params = params && commonJs.obj.removeNullKey(params)
        return request({
            url: BASE_URL + '/apiList',
            method: 'get',
            params,

        })
    },

    //后台日志
    systemList(params) {
        params = params && commonJs.obj.removeNullKey(params)
        return request({
            url: BASE_URL + '/systemList',
            method: 'get',
            params,

        })
    },

    //商品浏览量排名
    goodsRank(params) {
        params = params && commonJs.obj.removeNullKey(params)
        return request({
            url: BASE_URL + '/goodsRank',
            method: 'get',
            params,

        })
    },
}